import { QueryClient } from '@tanstack/react-query';

import { GetHospitalByIdQuery } from '@/types/bff/gql-schema';
import { HospitalResponse } from '@/types/hospital';

import { useGetHospitalByIdQuery } from './faceToFace.gql.impl';

interface GetHospital {
  data?: HospitalResponse;
  refetch: () => void;
  isLoading: boolean;
}

const useGetHospitalById = (hospitalPid: string): GetHospital => {
  const { data, isLoading, refetch } = useGetHospitalByIdQuery(
    {
      publicId: hospitalPid,
    },
    {
      select: convertToHospitalResponse,
      staleTime: 1000 * 60 * 5,
    },
  );
  return { data, refetch, isLoading };
};

export default useGetHospitalById;

const prefetchQuery = async (queryClient: QueryClient, hospitalPid: string) => {
  const params = { publicId: hospitalPid };

  await queryClient.prefetchQuery(useGetHospitalByIdQuery.getKey(params), useGetHospitalByIdQuery.fetcher(params));
};

useGetHospitalById.prefetchQuery = prefetchQuery;

const convertToHospitalResponse = (data: GetHospitalByIdQuery): HospitalResponse => {
  return {
    ...data.getHospitalByPublicId,
  };
};
